<template>
  <v-container fill-height fluid class="grey">
    <v-row justify="center">
      <v-card width="550">
        <v-card-title class="text-h5 font-weight-light">
          <v-icon size="40" class="primary--text mb-2 pr-2" left>mdi-account-clock</v-icon>
          Account Pending
        </v-card-title>
        <v-card-text justify-center>
          Please allow up to 48 business hours for the completion of your account setup.<br>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'RestrictedAccess'
}
</script>
